import { render, staticRenderFns } from "./CreditsPage.vue?vue&type=template&id=1dd8a17e&scoped=true&"
import script from "./CreditsPage.vue?vue&type=script&lang=js&"
export * from "./CreditsPage.vue?vue&type=script&lang=js&"
import style0 from "./CreditsPage.vue?vue&type=style&index=0&id=1dd8a17e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd8a17e",
  null
  
)

export default component.exports